import { wrapComponent } from '../common/Wrapped';
import { cloneDeep } from 'lodash';
import currentState from './../helpers/CurrentState';

class Layout {
  components = [];
  listComponent = {};

  set(layout, store) {
    this.layout = layout;
    this.store = store;
  }

  register(component) {
    this.components.push(component);
    this.layout.registerComponent(
      component.name,
      wrapComponent(component.component, this.store),
    );
  }

  add(component) {
    this.layout.root.contentItems[0].addChild({
      type: 'react-component',
      component: component.name,
      title: component.title,
      tooltip: component.tooltip,
    });
  }

  isContain(component) {
    return this.components.some(item => item.name === component.name);
  }

  drag(element, component, props = {}) {
    return this.layout.createDragSource(element, {
      props,
      title: component.title,
      type: 'react-component',
      component: component.name,
      tooltip: component.tooltip,
    });
  }

  removeAdditionalProps = item => {
    if (!item.content) {
      const { dragCode: _, tab: __, subTab: ___, ...rest } = item.props;
      item.props = rest;
      return;
    }
    item.content.forEach(it => {
      this.removeAdditionalProps(it);
    });
  };

  getStateFromConfig = data => {
    let config = null,
      state = {};
    try {
      config = this.layout.toConfig();

      if (this.layout.isInitialised && config) {
        config.data = data;
        this.removeAdditionalProps(config);
        state = JSON.stringify(config);
      }
    } catch (err) {
      console.error(err);
    }

    return state;
  };

  saveState = (name, config) => {
    localStorage.setItem(name, config);
  };

  getState = name => {
    return localStorage.getItem(name);
  };

  stackCreated(callback) {
    this.layout.on('stackCreated', callback);
  }

  async reload(config) {
    try {
      const state = cloneDeep(currentState.getAll());
      const newConfig = config || this.layout.toConfig();
      if (this.layout.root && Array.isArray(this.layout.root.contentItems)) {
        this.layout.root.contentItems.forEach(item => {
          item.remove();
        });
      }
      if (!newConfig.content[0]) {
        return;
      }
      while (!this.layout || !this.layout.root) {
        await new Promise(resolve => {
          setTimeout(() => {
            resolve(true);
          }, 50);
        });
      }
      this.layout.root.addChild(newConfig.content[0]);
      setTimeout(() => {
        currentState.apply(state);
      }, 0);
    } catch (e) {
      console.log(e);
    }
  }

  removeAll() {
    this.layout.root.contentItems.forEach(item => {
      item.remove();
    });
  }
}

export default new Layout();
